import React from "react";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
function Sitemap(){
  return(<>
       
            
              <div className="container mt-5 mb-5">
              <h5 className="bg_text fw-bold fs-4">FruitShop All Links</h5>
              <div class="fancy-border"></div>
              <div className="card mt-5 text-uppercase">
              <Nav.Link as ={Link} to="/" class="nav-item nav-link p-0 text-white">Home</Nav.Link>
                <Nav.Link as ={Link} to="/about" class="nav-item nav-link p-2  text-white">About</Nav.Link>
                <Nav.Link as ={Link} to="/ourfruit" class="nav-item nav-link p-2  text-white">OurFruits</Nav.Link>
                <Nav.Link as ={Link} to="/seasonal" class="nav-item nav-link p-2 text-white">Seasonal</Nav.Link>
                <Nav.Link as ={Link} to="/testimonial" class="nav-item nav-link p-2  text-white">Testimonials</Nav.Link>
                <Nav.Link as ={Link} to="/contact" class="nav-item nav-link p-2 text-white">Contact</Nav.Link>
                <Nav.Link as ={Link} to="/sitemao" class="nav-item nav-link p-2  text-white">FAQS</Nav.Link>
                
              </div> 
              </div>  




  </>);
}
export default Sitemap;